import { Voter } from '../voter';

export class ACLVoter extends Voter {
    constructor(loader) {
        super();
        this.loader = loader;
    }

    /**
     * @returns {ACL} Loaded ACL table
     */
    get acl() {
        if (!this._acl) {
            this._acl = this.loader();
        }

        return this._acl;
    }

    /**
     * @param {AccessPermissionRequest} request Request in question
     * @returns {boolean} True if request supported by this voter
     */
    // eslint-disable-next-line no-unused-vars
    supports(request) {
        return true;
    }

    vote(request) {
        return this.acl.isGranted(request);
    }

    /**
     * @param {AccessPermissionRequest} request Request in question
     * @param {string|function(*): boolean} matches Permission matching predicate
     * @returns {boolean} <code>True</code> - if grant status given, else <code>False</code>
     */
    grantsInArrayPayload(request, matches) {
        const predicate = typeof matches === 'function' ? matches : (item) => item === matches;
        let role = this.acl.getRole(request.role);

        while (role) {
            const resource = role.getResource(request.resource);

            if (resource) {
                if (resource.payload) {
                    const { grant, reject } = resource.payload;

                    if (grant && (grant === '*' || grant.some(predicate))) {
                        return true;
                    }

                    if (reject && (reject === '*' || reject.some(predicate))) {
                        return false;
                    }
                } else if (role.isGranted(request, true)) {
                    return true;
                }
            }

            role = role.parent;
        }

        return false;
    }
}
